import React, { useState } from "react";
import PlacesAutocomplete,{geocodeByAddress,getLatLng} from "react-places-autocomplete";
import {Input} from 'antd';
import './styles.scss';
const PlacesAutoComplete = ({flag, distancia, setDistancia}) => {

    const changeValue  = (value)=>{
        setDistancia({
            place: value
        });
        
        flag(value.length >0 ? false:true);

    }
    const selectValue = async(value) => {
        const results = await geocodeByAddress(value);
        const latLng = await getLatLng(results[0]);
        setDistancia({
            place: value,
            lat:latLng.lat,
            lng: latLng.lng
        })
        flag(false);


    }
   
  return (
    <>
    <div >


      <PlacesAutocomplete
       
       value={distancia.place}
       onChange={changeValue}
       onSelect={selectValue}
       >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
            <div>
            <Input style = {{borderRadius:'20px'}} {...getInputProps({ placeholder: "Buscar direccion..." })} />

            <div className="container-autocomplete">
              {loading ? (
                  <div>...Cargando</div>
                  ) : null}
              <div className="container-autocomplete-suggestions">

              {suggestions.map((suggestion) => {
                const style = {
                      backgroundColor: suggestion.active ? "#41b6e6" : "#fff",
                    };
                    
                    return (
                        <div {...getSuggestionItemProps(suggestion, { style })}>
                    {suggestion.description}
                  </div>
                );
              })}
              </div>
            </div>
          </div>
        )}
      </PlacesAutocomplete>
        </div>
    </>
  );
};

export default PlacesAutoComplete;